import {
  ICategorySoldProducts,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { isCategoryChecked } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/soldProducts/checkBoxThree/helpers/isCategoryChecked'

import { deleteCategory } from './deleteCategory'
import { isExistCategoryKeyInData } from './isExistCategoryKeyInData'

export const checkCategory =
  (
    updateFormData: (data: TComplexSectionData) => void,
    data: ICategorySoldProducts[],
    staticData: ICategorySoldProducts[]
  ) =>
  (productCategory: ICategorySoldProducts) => {
    const found = staticData.find((el) => el.Key === productCategory.Key)
    const products = [...(found?.Products ?? [])]
    if (!isExistCategoryKeyInData(data, productCategory.Key)) {
      updateFormData([
        ...(data || []),
        { Key: productCategory.Key, Name: productCategory.Name, Products: products },
      ])
      return
    }
    if (isCategoryChecked({ selectedData: data, staticData, categoryKey: productCategory.Key })) {
      deleteCategory({ updateFormData, productCategory, data })
      return
    }
    const newData = data.map((el) => {
      if (el.Key === productCategory.Key) {
        return { ...el, Products: products }
      }
      return el
    })
    updateFormData(newData)
  }
